// extracted by mini-css-extract-plugin
module.exports = {"comp":"HomeownersSection4_comp__of_p0"};